import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import { contactNamesWithPartnerNames } from './selectors/partners/contact-names-with-partner-names';
import { employeeShortNamesOrAll } from './selectors/employees/employee-short-names-or-all';
import { capitalize, joinWithAnd } from '../utilities/text';

import { functionNameWithAssignedNames } from './functionNameWithAssignedNames';
import type { NameEntry } from './selectors/employees/name-entry';
import type { ContactsAsUsers } from './selectors/partners/contacts-as-users';

export function eventAssigneesText(
  event: any,
  functions: FunctionViewModel[],
  employees: NameEntry[],
  contacts: ContactsAsUsers[],
): string {
  let list: string[] = [];
  if (event.functionUuid) {
    list.push(functionNameWithAssignedNames(event.functionUuid, functions, employees));
  }
  if (event.employees?.length) {
    list = list.concat(employeeShortNamesOrAll(employees, event.employees));
  }
  if (event.contacts?.length) {
    list = list.concat(contactNamesWithPartnerNames(event.contacts, contacts));
  }
  return capitalize(joinWithAnd(list));
}
